import { useSyncExternalStore } from 'react';

// Tiny module-level store so any "Connect Wallet" button (Header, Portfolio
// prompt, …) opens the single WalletModal rendered at the app root.
let open = false;
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

export function openWalletModal() {
  open = true;
  emit();
}

export function closeWalletModal() {
  open = false;
  emit();
}

export function useWalletModalOpen() {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => open,
    () => open,
  );
}
